import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white px-4 font-body text-zinc-900" data-testid="payment-cancel-page">
      <img src="/assets/logo-black.png" alt="Tiger Clothing" className="mb-8 h-20 w-auto" />
      <div className="flex max-w-md flex-col items-center gap-4 text-center">
        <XCircle size={56} className="text-zinc-400" />
        <h1 className="font-display text-4xl uppercase">Checkout Cancelled</h1>
        <p className="font-body text-sm text-zinc-500">
          No charge was made. Your cart is still saved — pick up where you left off.
        </p>
        <Link
          to="/gb/en/home.html#shop"
          data-testid="cancel-shop-link"
          className="mt-4 bg-tiger px-8 py-4 font-heading text-sm font-bold uppercase tracking-widest text-black transition-colors hover:bg-tiger-hover"
        >
          Return To Shop
        </Link>
      </div>
    </div>
  );
}
